if (!customElements.get('customer-stories')) {
  customElements.define('customer-stories', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', this.onClick.bind(this), { signal: this.controller.signal });
      this.reviewAttempts = 0;
      this.initReviews();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.reviewTimer);
    }
    initReviews() {
      if (window.okeWidgetApi?.initAllWidgets) window.okeWidgetApi.initAllWidgets();
      else if (++this.reviewAttempts < 20) this.reviewTimer = setTimeout(() => this.initReviews(), 300);
    }
    onClick(event) {
      const filter = event.target.closest('[data-story-filter]');
      if (filter) {
        this.querySelectorAll('[data-story-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
        this.querySelectorAll('[data-story-card]').forEach(card => { card.hidden = filter.dataset.storyFilter !== 'all' && card.dataset.storyCard !== filter.dataset.storyFilter; });
      }
      const navigation = event.target.closest('[data-review-index], [data-review-step]');
      if (navigation) {
        const card = navigation.closest('[data-story-card]');
        const slides = [...card.querySelectorAll('[data-review]')];
        const dots = [...card.querySelectorAll('[data-review-index]')];
        const current = Math.max(0, slides.findIndex(slide => slide.getAttribute('aria-hidden') === 'false'));
        const index = navigation.hasAttribute('data-review-index') ? dots.indexOf(navigation) : (current + Number(navigation.dataset.reviewStep) + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.classList.toggle('story-roff', i !== index); slide.setAttribute('aria-hidden', String(i !== index)); });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }
      const play = event.target.closest('[data-play-video]');
      if (play) {
        const stage = play.closest('[data-video-stage]');
        const video = document.createElement(stage.dataset.kind === 'youtube' ? 'iframe' : 'video');
        video.src = stage.dataset.videoUrl;
        if (video.tagName === 'IFRAME') {
          video.title = play.getAttribute('aria-label');
          video.allow = 'autoplay; encrypted-media; picture-in-picture';
          video.allowFullscreen = true;
        } else {
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          video.preload = 'metadata';
        }
        this.querySelectorAll('video').forEach(other => other.pause());
        this.querySelectorAll('[data-video-stage] iframe').forEach(other => {
          const previousStage = other.closest('[data-video-stage]');
          other.remove();
          previousStage.querySelector('[data-play-video]').hidden = false;
          previousStage.querySelector('img').hidden = false;
        });
        stage.append(video);
        play.hidden = true;
        stage.querySelector('img').hidden = true;
        if (video.tagName === 'VIDEO') video.play().catch(() => { video.controls = true; });
      }
    }
  });
}
if (!customElements.get('story-product-form')) {
  customElements.define('story-product-form', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.form = this.querySelector('form');
      this.submit = this.querySelector('[type="submit"]');
      this.error = this.querySelector('[role="alert"]');
      const options = { signal: this.controller.signal };
      this.form.addEventListener('submit', this.addToCart.bind(this), options);
      this.form.addEventListener('change', () => {
        const selected = this.form.querySelector('[name="id"]:checked');
        const price = [...this.closest('customer-stories').querySelectorAll('[data-story-price-for]')].find(el => el.dataset.storyPriceFor === this.form.id);
        if (selected && price) {
          price.textContent = selected.dataset.price;
          if (selected.dataset.compare) { const compare = document.createElement('s'); compare.textContent = selected.dataset.compare; price.append(' ', compare); }
        }
        this.error.hidden = true;
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
    async addToCart(event) {
      event.preventDefault();
      if (this.pending || !this.form.reportValidity()) return;
      const selected = this.form.querySelector('[name="id"]:checked:not(:disabled)');
      if (!selected) return;
      const drawer = document.querySelector('cart-drawer');
      const label = this.submit.textContent;
      const id = selected.value;
      this.pending = true;
      this.submit.disabled = true;
      this.submit.textContent = this.dataset.addingLabel;
      this.error.hidden = true;
      let added = false;
      try {
        drawer?.setActiveElement(this.submit);
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: drawer?.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.errorMessage);
        added = true;
        if (window._learnq) window._learnq.push(['track', 'Added to Cart', { id, quantity: 1 }]);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'story-product-form', productVariantId: id, cartData: result });
        if (drawer && result.sections && Object.values(result.sections).every(Boolean)) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        } else window.location.assign(window.routes?.cart_url || `${window.Shopify.routes.root}cart`);
      } catch (error) {
        if (added) { window.location.assign(window.routes?.cart_url || `${window.Shopify.routes.root}cart`); return; }
        this.error.textContent = error instanceof TypeError ? this.dataset.errorMessage : error.message;
        this.error.hidden = false;
      } finally {
        this.pending = false;
        this.submit.disabled = false;
        this.submit.textContent = label;
      }
    }
  });
}
